<div class="referral-wrapper current-referrals">
	<div class="row pb-2 pt-2" *ngIf="showRequestSentMsg">
		<div class="col-md-12">
			<div class="success-toaster">
				<i class="fas fa-check"></i>
				<span class="text ml-2" [translate]="'referral.summary.success-toaster.referral-sent'">
					Your appointment request has been sent
				</span>
				<span class="icon right" (click)="showRequestSentMsg = false" appEheAnalytics>
					<i class="fas fa-times"></i>
				</span>
			</div>
		</div>
	</div>
	<div class="row pt-2">
		<div class="col-md-12 table-container">
			<app-digital-banner></app-digital-banner>
			<table class="summary-table table-theme ehe-table">
				<thead>
					<tr>
						<th class="table-header" [translate]="'referral.summary.current-referrals.table.specialty'">Specialty</th>
						<th class="table-header" [translate]="'referral.summary.current-referrals.table.last-updated'">
							Last Updated
						</th>
						<th class="table-header" [translate]="'referral.summary.current-referrals.table.source'">Source</th>
					</tr>
				</thead>
				<tbody>
					<ng-container *ngFor="let category of data?.category">
						<ng-container *ngFor="let referral of category?.referral">
							<tr>
								<td>
									<span>{{ referral?.specialtyName }}</span>
								</td>
								<td>
									<span class="table-label">Last Updated: </span>{{ referral?.lastUpdatedDate }}
									<span *ngIf="referral.new" class="badge">New</span>
								</td>
								<td>
									<span class="table-label">Source: </span>
									<span>{{ referralStatus[category.name] }}</span>
								</td>
							</tr>
						</ng-container>
					</ng-container>
					<ng-container *ngIf="noData">
						<tr class="align-center">
							<td colspan="3">{{ noDataMsg }}</td>
						</tr>
					</ng-container>
				</tbody>
			</table>
		</div>
	</div>
</div>
